// CommitChart.ts
import { Component, Mixins } from 'vue-property-decorator'
import { Pie, mixins } from 'vue-chartjs'

@Component({
  extends: Pie, // this is important to add the functionality to your component
  mixins: [mixins.reactiveProp]
})
export default class CommitChart extends Mixins(mixins.reactiveProp, Pie) {
  mounted () {
    // Overwriting base render method with actual data.

    this.renderChart(this.chartData, {
      rotation: 1 * Math.PI,
      circumference: 1 * Math.PI,
      legend: {
        display: false
      },
      tooltips: {
        enabled: true
      },
      elements: {
        arc: {
          borderWidth: 0
        }
      },
      maintainAspectRatio: true,
      plugins: {
        datalabels: {
          formatter: (value: any, ctx: any) => {
            let sum = 0
            const dataArr = ctx.chart.data.datasets[0].data
            dataArr.map((data: any) => {
              sum += data
            })
            const percentage = (value * 100 / sum).toFixed(2) + '%'
            return percentage
          },
          color: '#fff'
        }
      }
    })
  }
}
